export default "__VITE_ASSET__Oc$52zoF__"